import { MetricDefinition } from 'libs/end-to-end/src/types/databases/metrics/metric-definition';
import { FocusAreaDefinition } from 'libs/end-to-end/src/types/databases/focus-areas/focus-area-definition';
import { TransformUniqueValuesByColumnItem } from 'libs/end-to-end/src/types/databases/transform/transform-insights';
import { FilterSetDefinitions } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { defaultCalibrationFramingMapping } from 'libs/end-to-end/src/utils/databases/default-calibration-framing-mapping';
import { constructMetricWhiteLabelingWithDefaults } from 'libs/end-to-end/src/utils/databases/construct-metric-white-labeling-with-defaults';
import { convertStaticControlVariableDefinitions } from 'libs/end-to-end/src/utils/databases/convert-static-control-variable-definitions';
import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';
import { BiasTaskId } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-bias-task';
import { BiasTaskIdToTaskRecord } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-bias-task';
import { BiasTestTaskIds } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-bias-task';
import { isBiasTestTaskId } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-bias-task';

const tasksForMetricHasAtLeastOneEnabledBiasTestTask = (
  tasksForMetric: BiasTaskIdToTaskRecord,
): boolean => {
  for (const biasTestTaskId of BiasTestTaskIds) {
    const taskIsDefinedAndEnabled = Boolean(tasksForMetric[biasTestTaskId]);
    if (taskIsDefinedAndEnabled) {
      return true;
    }
  }

  return false;
};

export const convertMetricDefinitionToMyMetricDefinition = ({
  metricDefinition,
  focusAreaDefinition,
  isMetricBoolean,
  uniqueValuesByColumn,
  filterSetDefinitions,
  performanceMetric,
  computeStaticControlVars,
  tasksForMetric,
}: {
  metricDefinition: MetricDefinition;
  focusAreaDefinition: FocusAreaDefinition;
  isMetricBoolean: boolean;
  uniqueValuesByColumn: TransformUniqueValuesByColumnItem[];
  filterSetDefinitions: FilterSetDefinitions;
  performanceMetric: MetricDefinition | null;
  computeStaticControlVars: boolean;
  tasksForMetric: BiasTaskIdToTaskRecord;
}): MyMetricDefinition => {
  return {
    columnHeaderValue: metricDefinition.columnHeaderValue,
    displayName: metricDefinition.displayName,
    isPreferred: metricDefinition.isPreferred,
    calibrationFraming:
      metricDefinition.calibrationFraming ??
      defaultCalibrationFramingMapping[focusAreaDefinition.focusArea],
    skillFraming:
      metricDefinition.skillFraming ??
      defaultCalibrationFramingMapping[focusAreaDefinition.focusArea],
    whiteLabeling: constructMetricWhiteLabelingWithDefaults({
      metricWhiteLabeling: metricDefinition.whiteLabeling,
      focusArea: focusAreaDefinition.focusArea,
    }),
    isMetricBoolean: isMetricBoolean,
    staticControlVariableDefinitions: computeStaticControlVars
      ? convertStaticControlVariableDefinitions({
          uniqueValuesByColumn,
          filterSetDefinitions,
          focusAreaDefinition,
          performanceMetric,
        })
      : [],
    hasBiasTestTasks:
      tasksForMetricHasAtLeastOneEnabledBiasTestTask(tasksForMetric),
    description: metricDefinition.description ?? '',
    unit: metricDefinition.unit,
  };
};
